import { call, put, select, takeEvery } from "redux-saga/effects";

import {
  getCampaignsCountBy,
  getPaymentCostInspectionReportFilters,
  getPaymentCostInspectionReportList,
  getQualityFilters,
  getQualityStats,
  getQualityWidgets,
  getReportQualityEventsStats,
  getReportRentStats,
  getReportRentWidgets,
  getTopManagementAppProfit,
  getTopManagementClientSpend,
  getTopManagementMediaBuyerProfit,
  getTopManagementMediaBuyerSpend,
  getTopManagementMediaBuyerStats,
  getTopManagementOfferProfit,
  getTopManagementProfit,
  postReportRequestDataUpdate,
} from "../../helpers/jwt_helper";

import {
  GET_PAYMENT_COST_INSPECTION_REPORT_FILTERS,
  GET_PAYMENT_COST_INSPECTION_REPORT_LIST,
  GET_QUALITY_BANNER_STATS,
  GET_QUALITY_CAMP_STATS,
  GET_QUALITY_FILTERS,
  GET_QUALITY_MEDIA_SOURCE,
  GET_QUALITY_WIDGETS,
  GET_REPORT_CAMPAIGNS_COUNT_BY,
  GET_TOP_MANAGEMENT_APP_PROFIT,
  GET_TOP_MANAGEMENT_CLIENT_SPEND,
  GET_TOP_MANAGEMENT_MEDIABUYER_PROFIT,
  GET_TOP_MANAGEMENT_MEDIABUYER_SPEND,
  GET_TOP_MANAGEMENT_MEDIABUYER_STATS,
  GET_TOP_MANAGEMENT_OFFER_PROFIT,
  GET_TOP_MANAGEMENT_PROFIT,
  REQUEST_DATA_UPDATE,
  GET_REPORT_QUALITY_EVENTS_STATS,
  WIDGET_LOADER,
  GET_QUALITY_ADGROUPS_STATS,
  GET_REPORT_RENT_STATS,
  GET_REPORT_RENT_WIDGETS,
} from "./actionTypes";

import {
  hidePaymentCostInspectionReportLoader,
  hideReportLoader,
  mediaSourceLoader,
  QualityCampStatsLoader,
  setPaymentCostInspectionReportFilters,
  setReportEventsStats,
  setPaymentCostInspectionReportList,
  setQualityBannerStats,
  setQualityCampStats,
  setQualityFilters,
  setQualityMediaSource,
  setQualityTopManagementMediaBuyerSpend,
  setQualityTopManagementMediaBuyerStats,
  setQualityWidgets,
  setReportCampaignCountByApp,
  setReportCampaignCountByClient,
  setReportCampaignCountByMediaBuyer,
  setReportCampaignCountByOffer,
  setTopManagementAppProfit,
  setTopManagementClientSpend,
  setTopManagementMediaBuyerProfit,
  setTopManagementOfferProfit,
  setTopManagementProfit,
  showPaymentCostInspectionReportLoader,
  showReportLoader,
  widgetLoader,
  getReportEventsStats,
  setQualityEvents,
  QualityAdgroupsLoader,
  setQualityAdgroupsStats,
  setReportRentStatsLoader,
  setReportRentStats,
  setReportRentWidgets,
  setReportRentWidgetsLoader,
} from "./actions";

import {
  DEFAULT_REPORT_WIDGET_FIRST,
  formatNumbersForTable,
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";

function* onGetQualityMediaSource({ payload: { data, events_params } }) {
  try {
    yield put(mediaSourceLoader());
    let response = yield call(getQualityStats, {
      count_by: "media_source",
      currency: data.currency,
      tracker_app_id: data.app_id,
      start_date: data.start_date,
      end_date: data.end_date,
      media_source: data.media_source,
      mediabuyer: data.mediabuyers,
      ordering: data?.ordering || "",
    });

    const { rows, widget_data } = response;
    if (events_params && events_params?.event_name) {
      let media_sources = []
      rows.map(i => {
        media_sources.push(i?.media_source)
      })
      yield put(getReportEventsStats({
        ...events_params,
        media_source: media_sources.join(','),
      }))
    }
    yield put(setQualityMediaSource(rows));


    yield put(mediaSourceLoader());
  } catch (error) {
    yield put(mediaSourceLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetQualityCampStats({ payload: { data, events_data } }) {
  try {
    yield put(QualityCampStatsLoader());

    let response = yield call(getQualityStats, {
      count_by: "campaign",
      size: data.sizePerPage,
      currency: data.currency,
      page: data.page,
      tracker_app_id: data.app_id,
      start_date: data.start_date,
      end_date: data.end_date,
      campaign_id: data.campaign_ids,
      campaign_name: data.campaign_names,
      mediabuyer: data?.mediabuyers,
      media_source: data?.media_source,
      ordering: data?.ordering || "",
    });

    const { rows, widget_data } = response;
    response = {
      ...data,
      results: rows.map(i => ({
        ...i,
        created_at: new Date(i.created_at).toDateString(),
      })),
    };

    if (events_data && events_data.event_name) {
      let comp_ids = []
      response.map(i => {
        comp_ids.push(i?.campaign_id)
      })
      yield put(getReportEventsStats({
        ...events_data,
        campaign_id: comp_ids.join(','),
      }))
    }

    yield put(setQualityCampStats(response));
    yield put(QualityCampStatsLoader());
  } catch (error) {
    yield put(QualityCampStatsLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetQualityBannerStats({ payload: { data, events_params } }) {
  try {
    yield put(showReportLoader());
    let response = yield call(getQualityStats, {
      count_by: "banner",
      size: data.sizePerPage,
      currency: data.currency,
      page: data.page,
      adgroup_id: data.adgroup_id,
      tracker_app_id: data?.app_id,
      start_date: data.start_date,
      end_date: data.end_date,
      mediabuyer: data.mediabuyers,
      media_source: data?.media_source,
      ordering: data?.ordering || "",
    });
    const { rows, widget_data } = response;

    response = {
      ...data,
      results: rows.map(i => ({
        ...i,
        created_at: new Date(i.created_at).toDateString(),
      })),
    };

    if (events_params && events_params.event_name) {
      let ad_ids = []
      response.results.map(i => {
        ad_ids.push(i?.ad_id)
      })

      yield put(getReportEventsStats({
        ...events_params,
        ad_id: ad_ids.join(','),
      }))
    }

    yield put(setQualityBannerStats(response));
    yield put(hideReportLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetQualityAdgroupsStats({ payload: data }) {
  try {
    yield put(QualityAdgroupsLoader());
    let response = yield call(getQualityStats, {
      count_by: "adgroup",
      size: data.sizePerPage,
      currency: data.currency,
      page: data.page,
      tracker_app_id: data.app_id,
      start_date: data.start_date,
      end_date: data.end_date,
      campaign_id: data.campaign_id,
      campaign_name: data.campaign_names,
      mediabuyer: data?.mediabuyers,
      media_source: data?.media_source,
      ordering: data?.ordering || "",
    });
    const { rows, widget_data } = response;

    response = {
      ...data,
      results: rows.map(i => ({
        ...i,
        created_at: new Date(i.created_at).toDateString(),
      })),
    };
    yield put(setQualityAdgroupsStats(response));
    yield put(QualityAdgroupsLoader());
  } catch (error) {
    yield put(QualityAdgroupsLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetQualityFilters({ payload: data }) {
  try {
    yield put(showReportLoader());
    let response = yield call(getQualityFilters, {
      app_id: data.app_id,
      start_date: data.start_date,
      end_date: data.end_date,
    });
    yield put(setQualityFilters(response));
    yield put(hideReportLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetQualityWidgets({ payload: data }) {
  try {
    yield put(widgetLoader());
    let response;
    // if (data.media_source !== undefined) {
    response = yield call(getQualityWidgets, {
      currency: data.currency,
      app_id: data.app_id,
      adgroup_id: data?.adgroup_id,
      media_source: data?.media_source,
      campaign_id: data?.campaign_id,
      mediabuyer: data?.mediabuyers,
      campaign_id: data?.campaign_id,
      start_date: data.start_date,
      end_date: data.end_date,
    });
    // } else if (data.campaign_id !== undefined) {
    //   response = yield call(getQualityWidgets, {
    //     currency: data.currency,
    //     app_id: data.app_id,
    //     mediabuyer: data.mediabuyers,
    //     campaign_id: data.campaign_id,
    //     start_date: data.start_date,
    //     end_date: data.end_date,
    //     ad_id: data.ad_id,
    //   });
    // } else {
    //   response = yield call(getQualityWidgets, {
    //     currency: data.currency,
    //     app_id: data.app_id,
    //     start_date: data.start_date,
    //     end_date: data.end_date,
    //   });
    // }
    yield put(setQualityWidgets(response));
    yield put(widgetLoader());
  } catch (error) {
    yield put(widgetLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetTopManagementMediaBuyerProfit({ payload: data }) {
  try {
    yield put(showReportLoader());
    let response = yield call(getTopManagementMediaBuyerProfit, {
      start_date: data.start_date,
      end_date: data.end_date,
      mediabuyer: data?.mediabuyer,
    });
    yield put(setTopManagementMediaBuyerProfit(response));
    yield put(hideReportLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetTopManagementOfferProfit({ payload: data }) {
  try {
    yield put(showReportLoader());
    let response = yield call(getTopManagementOfferProfit, {
      start_date: data.start_date,
      end_date: data.end_date,
      offer_id: data?.offer_id,
    });
    yield put(setTopManagementOfferProfit(response));
    yield put(hideReportLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetTopManagementProfit({ payload: data }) {
  try {
    yield put(showReportLoader());
    let response = yield call(getTopManagementProfit, {
      start_date: data.start_date,
      end_date: data.end_date,
    });
    yield put(setTopManagementProfit(response));
    yield put(hideReportLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetTopManagementMediaBuyerStats({ payload: data }) {
  try {
    yield put(showReportLoader());
    let response = yield call(getTopManagementMediaBuyerStats, {
      start_date: data.start_date,
      end_date: data.end_date,
      mediabuyer: data?.mediabuyer,
    });
    yield put(setQualityTopManagementMediaBuyerStats(response));
    yield put(hideReportLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetTopManagementMediaBuyerSpend({ payload: data }) {
  try {
    yield put(showReportLoader());
    let response = yield call(getTopManagementMediaBuyerSpend, {
      start_date: data.start_date,
      end_date: data.end_date,
      mediabuyer: data?.mediabuyer,
    });
    yield put(setQualityTopManagementMediaBuyerSpend(response));
    yield put(hideReportLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetTopManagementAppProfit({ payload: data }) {
  try {
    yield put(showReportLoader());
    let response;
    if (data.tracker_app_id !== undefined) {
      response = yield call(getTopManagementAppProfit, {
        tracker_app_id: data.tracker_app_id,
        start_date: data.start_date,
        end_date: data.end_date,
      });
    } else {
      response = yield call(getTopManagementAppProfit, {
        start_date: data.start_date,
        end_date: data.end_date,
      });
    }
    yield put(setTopManagementAppProfit(response));
    yield put(hideReportLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetReportCampaignsBy({ payload: data, by }) {
  try {
    yield put(showReportLoader());
    switch (by) {
      case "app": {
        let response = yield call(getCampaignsCountBy, {
          start_date: data.start_date,
          end_date: data.end_date,
          count_by: by,
          tracker_app_id: data?.tracker_app_id,
        });
        return yield put(setReportCampaignCountByApp(response));
      }
      case "mediabuyer": {
        let response = yield call(getCampaignsCountBy, {
          start_date: data.start_date,
          end_date: data.end_date,
          count_by: by,
          mediabuyer: data?.mediabuyer,
        });
        return yield put(setReportCampaignCountByMediaBuyer(response));
      }
      case "client": {
        let response = yield call(getCampaignsCountBy, {
          start_date: data.start_date,
          end_date: data.end_date,
          count_by: by,
          client_id: data?.client_id,
        });
        return yield put(setReportCampaignCountByClient(response));
      }
      case "offer": {
        let response = yield call(getCampaignsCountBy, {
          start_date: data.start_date,
          end_date: data.end_date,
          count_by: by,
          offer_id: data?.offer_id,
        });
        return yield put(setReportCampaignCountByOffer(response));
      }
    }
    yield put(hideReportLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetTopManagementClientSpend({ payload: data }) {
  try {
    yield put(showReportLoader());
    let response = yield call(getTopManagementClientSpend, {
      start_date: data.start_date,
      end_date: data.end_date,
      client_id: data?.client_id,
    });
    yield put(setTopManagementClientSpend(response));
    yield put(hideReportLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetPaymentCostInspectionReportList({ payload: data }) {
  try {
    yield put(showPaymentCostInspectionReportLoader());
    let response = yield call(getPaymentCostInspectionReportList, {
      media_source: data.media_source?.join(","),
      offer_id: data.offer_id?.join(","),
      currency: data.currency,
      start_date: data.start_date,
      end_date: data.end_date,
    });
    response = {
      ...response,
      results: response,
    };
    yield put(setPaymentCostInspectionReportList(response));
    yield put(hidePaymentCostInspectionReportLoader());
  } catch (error) {
    yield put(hidePaymentCostInspectionReportLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetInspectionFilters() {
  try {
    yield put(showPaymentCostInspectionReportLoader());
    let response = yield call(getPaymentCostInspectionReportFilters);
    response = {
      offers: response.offers.map(i => ({ value: i.id, label: i.name })),
      media_sources: response.media_sources.map(i => ({
        value: i.slug,
        label: i.name,
      })),
    };
    yield put(setPaymentCostInspectionReportFilters(response));
    yield put(hidePaymentCostInspectionReportLoader());
  } catch (error) {
    yield put(hidePaymentCostInspectionReportLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onUpdateRequestData({ payload: data }) {
  try {
    yield call(postReportRequestDataUpdate, data);
    showSuccessMessage(`The update process has started, please wait`);
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
  }
}

function* onGetReportEventsStats({ payload: params }) {
  try {
    const eventsCount = params?.event_name.split(",");
    const eventsArray = [];
    const TableStyleNums = {
      textAlign: "center",
      width: "auto",
      verticalAlign: "middle",
    };

    if (params.event_name.length > 0) {
      let response = yield call(getReportQualityEventsStats, params);

      eventsCount?.length > 0 &&
        eventsCount.map((event, key) => {
          eventsArray.push({
            id: `${event}_${key}`,
            Header: `${event}`,
            src: `${event}`,
            columns: [
              {
                id: `unique_users_${key}`,
                Header: "Unique Users",
                accessor: row =>
                  formatNumbersForTable(row[event]?.["unique_users"] || 0),
                style: { ...TableStyleNums, minWidth: 110 },
              },
              {
                id: `event_counter_${key}`,
                Header: "Counter",
                accessor: row =>
                  formatNumbersForTable(row[event]?.["event_counter"] || 0),
                style: { ...TableStyleNums, minWidth: 110 },
              },
              {
                id: `revenue_${key}`,
                Header: "Revenue",
                accessor: row =>
                  formatNumbersForTable(row[event]?.["revenue"] || 0),
                style: { ...TableStyleNums, minWidth: 110 },
              },
              {
                id: `eCPA_${key}`,
                Header: "eCPA",
                accessor: row =>
                  formatNumbersForTable(row[event]?.["eCPA"] || 0),
                style: { ...TableStyleNums, minWidth: 110 },
              },
            ],
          });
        });

      switch (params.grouping) {
        case "media_source":
          const media_source_data = yield select(
            state => state.Reporting.mediaSourceStats
          );
          let media_res = [...media_source_data.results];
          let update_media = [];

          media_res.map((i, k) => {
            let eID = response.findIndex(
              r => i.media_source == r?.media_source
            );
            eID >= 0
              ? update_media.push({
                ...media_res[k],
                [response[eID]?.event_name]: {
                  ...response[eID],
                },
              })
              : update_media.push(i);
          });

          yield put(setQualityEvents(eventsArray));
          yield put(setQualityMediaSource(update_media));
          break;
        case "campaign":
          const campaign_data = yield select(
            state => state.Reporting.camp_stats
          );
          let camp_res = [...campaign_data.results];
          let update_campaign = [];

          camp_res.map((i, k) => {
            let eID = response.findIndex(r => i.campaign_id == r?.campaign_id);
            eID >= 0
              ? update_campaign.push({
                ...camp_res[k],
                [response[eID]?.event_name]: {
                  ...response[eID],
                },
              })
              : update_campaign.push(i);
          });

          yield put(setQualityEvents(eventsArray));
          yield put(
            setQualityCampStats({
              ...campaign_data,
              results: update_campaign,
            })
          );
          break;
        case "adgroup":
          const adgroup_data = yield select(
            state => state.Reporting.adgroups_stats
          );
          let update_adgroup = [];
          let adgroup_res = [...adgroup_data.results];

          adgroup_res.map((i, k) => {
            let eID = response.findIndex(r => i.ad_id == r?.ad_id);
            eID >= 0
              ? update_adgroup.push({
                ...adgroup_res[k],
                [response[eID]?.event_name]: {
                  ...response[eID],
                },
              })
              : update_adgroup.push(i);
          });

          yield put(setQualityEvents(eventsArray));
          yield put(
            setQualityAdgroupsStats({
              ...adgroup_data,
              results: update_adgroup,
            })
          );
          break;
        case "banner":
          const banner_data = yield select(
            state => state.Reporting.banner_stats
          );
          let update_banner = [];
          let banner_res = [...banner_data.results];

          banner_res.map((i, k) => {
            let eID = response.findIndex(r => i.ad_id == r?.ad_id);
            eID >= 0
              ? update_banner.push({
                ...banner_res[k],
                [response[eID]?.event_name]: {
                  ...response[eID],
                },
              })
              : update_banner.push(i);
          });

          yield put(setQualityEvents(eventsArray));
          yield put(
            setQualityBannerStats({
              ...banner_data,
              results: update_banner,
            })
          );
          break;
      }
    } else {
      yield put(setQualityEvents([]));
    }
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
  }
}

function* onGetReportRentStats({ payload: params }) {
  try {
    yield put(setReportRentStatsLoader());
    let defParams = {
      currency: params.currency,
      page: params.page,
      ordering: params?.ordering || "",
      size: params?.sizePerPage || 10,
      start_date: params.start_date,
      end_date: params.end_date,
      count_by: params.count_by,
      client_id: params.client_id,
    };

    if (params?.media_source) defParams.media_source = params.media_source;
    if (params?.cabinet_name) defParams.cabinet_name = params.cabinet_name;
    if (params?.campaign_name) defParams.campaign_name = params.campaign_name;

    let response = yield call(getReportRentStats, defParams);
    yield put(setReportRentStats(response));
    yield put(setReportRentStatsLoader());
  } catch (e) {
    yield put(setReportRentStatsLoader());
    showErrorMessage(getErrorMessage(e));
  }
}

function* onGetReportRentWidgets({ payload: params }) {
  try {
    yield put(setReportRentWidgetsLoader());
    let widgetData = [
      ...(yield select(state => state.Reporting.reportRentWidgets)),
    ];

    let dt = {
      currency: params.currency,
      client_id: params.client_id,
      start_date: params.start_date,
      end_date: params.end_date,
    };

    if (params?.media_source) dt.media_source = params.media_source;
    if (params?.cabinet_name) dt.cabinet_name = params.cabinet_name;
    if (params?.campaign_name) dt.campaign_name = params.campaign_name;

    let response = yield call(getReportRentWidgets, { ...dt });
    if (response?.length > 0) {
      let filteredRes = {
        clicks_sum: response[0].clicks_sum,
        shows_sum: response[0].shows_sum,
        payment_sum: response[0].payment_sum,
        spend_sum: response[0].spend_sum,
        profit_sum: response[0].profit_sum,
      };

      Object.keys(filteredRes).forEach((key, idx) => {
        widgetData[idx].value = filteredRes[key];
      });

      widgetData[0] = {
        ...widgetData[0],
        badgeValue:
          response[0]?.shows_change > 0
            ? `+ ${response[0]?.shows_change}%`
            : response[0]?.shows_change !== undefined
              ? `- ${response[0]?.shows_change}%`
              : `Undefined`,
        color: response[0]?.shows_change > 0 ? "success" : "danger",
      };

      widgetData[1] = {
        ...widgetData[1],
        badgeValue:
          response[0]?.clicks_change > 0
            ? `+ ${response[0]?.clicks_change}%`
            : response[0]?.clicks_change !== undefined
              ? `- ${response[0]?.clicks_change}%`
              : `Undefined`,
        color: response[0]?.clicks_change > 0 ? "success" : "danger",
      };

      yield put(setReportRentWidgets(widgetData));
    } else {
      let emptyData = DEFAULT_REPORT_WIDGET_FIRST.map(i => {
        return {
          ...i,
          value: 0,
        };
      });
      yield put(setReportRentWidgets([...emptyData]));
    }

    yield put(setReportRentWidgetsLoader());
  } catch (e) {
    yield put(setReportRentWidgetsLoader());
    showErrorMessage(getErrorMessage(e));
  }
}

function* reportingSaga() {
  yield takeEvery(REQUEST_DATA_UPDATE, onUpdateRequestData);
  yield takeEvery(GET_QUALITY_BANNER_STATS, onGetQualityBannerStats);
  yield takeEvery(GET_QUALITY_CAMP_STATS, onGetQualityCampStats);
  yield takeEvery(GET_QUALITY_FILTERS, onGetQualityFilters);
  yield takeEvery(GET_QUALITY_WIDGETS, onGetQualityWidgets);
  yield takeEvery(GET_TOP_MANAGEMENT_PROFIT, onGetTopManagementProfit);
  yield takeEvery(GET_TOP_MANAGEMENT_APP_PROFIT, onGetTopManagementAppProfit);
  yield takeEvery(GET_REPORT_CAMPAIGNS_COUNT_BY, onGetReportCampaignsBy);
  yield takeEvery(GET_QUALITY_MEDIA_SOURCE, onGetQualityMediaSource);
  yield takeEvery(
    GET_TOP_MANAGEMENT_CLIENT_SPEND,
    onGetTopManagementClientSpend
  );
  yield takeEvery(
    GET_TOP_MANAGEMENT_MEDIABUYER_PROFIT,
    onGetTopManagementMediaBuyerProfit
  );
  yield takeEvery(
    GET_TOP_MANAGEMENT_OFFER_PROFIT,
    onGetTopManagementOfferProfit
  );
  yield takeEvery(
    GET_TOP_MANAGEMENT_MEDIABUYER_SPEND,
    onGetTopManagementMediaBuyerSpend
  );
  yield takeEvery(
    GET_TOP_MANAGEMENT_MEDIABUYER_STATS,
    onGetTopManagementMediaBuyerStats
  );
  yield takeEvery(
    GET_PAYMENT_COST_INSPECTION_REPORT_LIST,
    onGetPaymentCostInspectionReportList
  );
  yield takeEvery(
    GET_PAYMENT_COST_INSPECTION_REPORT_FILTERS,
    onGetInspectionFilters
  );
  yield takeEvery(GET_REPORT_QUALITY_EVENTS_STATS, onGetReportEventsStats);
  yield takeEvery(GET_QUALITY_ADGROUPS_STATS, onGetQualityAdgroupsStats);
  yield takeEvery(GET_REPORT_RENT_STATS, onGetReportRentStats);
  yield takeEvery(GET_REPORT_RENT_WIDGETS, onGetReportRentWidgets);
}

export default reportingSaga;
